export enum UpgradeType {
    CpuOverclock,
    CpuThread,
    Broom,
    Ram,
    NpuCore,
}